import React from 'react';
import moment from "moment"
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';

import QuantitySelector from '../../QuantitySelector';
import Currency from '../../Currency';
import GroupTitle from '../../GroupTitle';
import SpotlioButton from '../../Button';
import SpotlioIcon from "../../Icon";
import Modal from "../../Modal";

import getDateFormat from "../../../utils/DateFormatRetriever";

import IntlMessage from '../../../LocaleEngine';

class Option extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            amount: 1,
            loading: false,
            modal: false
        }
    }
   
    changePrice = (index, value) => {
        this.setState({ amount: value })
    }

    addToCart = (element, amount) => {
        this.setState({ loading: true, amount: 1})
        this.props.addToCart(element, amount, () => this.setState({ loading: false }));
    }
    
    getCurrency = (displayType) => {
        const { amount } = this.state;
        const { element } = this.props;

        let currency = null;
        switch (displayType){
            case 1:
                currency = (
                    <React.Fragment>
                        <span className="originalPrice" ><Currency float={true} displayType={displayType} strikeThrough={true} onlyOriginal={true} value={element.OriginalPrice * amount}/></span>
                    </React.Fragment>
                )
            break;
            case 2:
                currency = (
                    <React.Fragment>
                        <span style={element.OriginalPrice - element.Price === 0 ? {visibility:'hidden'} : {}} className="originalPrice" ><Currency displayType={displayType} float={true} strikeThrough={true} onlyOriginal={true} value={element.OriginalPrice * amount}/></span>
                        <Currency float={true} value={element.Price * amount} />
                    </React.Fragment>
                )
            break;
            case 3:
            break;
            default:
            break;
        }
        return currency;
    }
    render(){
        const { props, state } = this;
        const { index, element, date, configuration } = props;
        const { amount, loading, modal } = state;

        return (
            <React.Fragment>
                <div className="product" key={index}>
                    <div className="productname">
                        {
                            configuration && configuration.config && configuration.config.products && configuration.config.products.more_info 
                            ?
                            <SpotlioIcon icon={"feather-info"} onClick={()=>this.setState({ modal: true })} size={20} />
                            :
                            null
                        }
                        <GroupTitle smallTitle={true} element={element} isShort={true} />
                    </div>
                    {
                        props.dateOfActivity
                        ?
                        <div className="date">
                            {moment.utc(props.dateOfActivity).format(getDateFormat())}
                        </div>
                        :
                        <div className="date">
                            {moment.utc(this.props.form.activities.startDate).format(getDateFormat())}
                        </div>
                    }
                    <div className="amount">
                        <QuantitySelector showSymbol={'x'} max={props.maxQuantity ? props.maxQuantity : element.Quantity} default={amount} name="items" whenChange={(index, value)=>this.changePrice(index, value)} />
                    </div>
                    <div className="price">
                        {
                            props.displayType !== undefined
                            ?
                            this.getCurrency(props.displayType)
                            :
                            <Currency float={true} value={element.Price * amount} />
                        }
                    </div>
                    {
                        props.isPackage
                        ?
                        <Button onClick={()=>this.addToCart(element, amount)} className="book">
                            <IntlMessage id="package.cell.option.add" />
                        </Button>
                        :
                        <SpotlioButton loading={loading} callBack={()=>this.addToCart(element, amount)} className="book">
                            <IntlMessage id={props.config && props.config.label_customization && props.config.label_customization.book_now_label ? props.config.label_customization.book_now_label : "activities.cell.option.book_now"} />
                        </SpotlioButton>
                    }
                </div>
                <div className="mobileProduct">
                    <div className="productname">
                        <GroupTitle smallTitle={true} element={element} isShort={true} />
                    </div>
                    <div className="productcontent">
                        <React.Fragment>
                            {
                                date
                                ?
                                <div className="date">
                                    {moment.utc(this.props.form.activities.startDate).format(getDateFormat())}
                                </div>
                                : 
                                null
                            }
                            <div className={"amount" + (!date ? '-nodate' : '')}>
                                <QuantitySelector showSymbol={'x'} max={props.maxQuantity ? props.maxQuantity : element.Quantity} default={amount} name="items" whenChange={(index, value)=>this.changePrice(index, value)} />
                            </div>
                        </React.Fragment>
                    </div>
                    <div className="pricing">
                        <Currency float={true} value={element.Price * amount}/>
                    </div>
                    {
                        props.isPackage
                        ?
                        <Button onClick={()=>this.addToCart(element, amount)} className="book">
                            <IntlMessage id="activities.cell.option.book_now" />
                        </Button>
                        :
                        <SpotlioButton loading={loading} callBack={()=>this.addToCart(element, amount)} className="book">
                            <IntlMessage id="activities.cell.option.book_now" />
                        </SpotlioButton>
                    }
                </div>
                <Modal
                    open={modal}
                    title={element.ProductName}
                    className="infoItem"
                    closeFn={()=>this.setState({ modal: false })}
                    footerContent={
                        <Button onClick={()=>this.setState({ modal: false })} className="secondary">
                            <IntlMessage id="profile.itinerary.modal.close" />
                        </Button>
                    }
                >
                    <div className="body">
                        <div>{element.ProductDescription}</div>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return { form: state.form.form }
}

export default connect(mapStateToProps)(Option)

